<shared-toolbar title="Edificios" [subtitle]="pageSubTitle">
  <shared-search-field class="mt-10" (inputValue)="fielInput = $event" [data]="dataSource" />
  <shared-button
    (click)="modalAction()"
    [typeBtn]="'button'"
    [color]="'accent'"
    [icon]="'add'"
    >Agregar
  </shared-button>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table class="w-full" [dataSource]="dataSource" matSort>
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
        <td mat-cell *matCellDef="let element">
          {{ element.code | uppercase }}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dirección</th>
        <td mat-cell *matCellDef="let element">{{ element.address }}</td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>País</th>
        <td mat-cell *matCellDef="let element">{{ element.country }}</td>
      </ng-container>

      <ng-container matColumnDef="business">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
        <td mat-cell *matCellDef="let element">{{ element.businessName }}</td>
      </ng-container>

      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="gotToBuildingFloors(element)">
              <mat-icon mat-icon-button>domain_add</mat-icon>
              <span>Niveles</span>
            </a>

            <a mat-menu-item (click)="modalAction(element)">
              <mat-icon mat-icon-button>edit</mat-icon>
              <span>Editar</span>
            </a>
            <a mat-menu-item (click)="modalDelete(element)">
              <mat-icon [color]="'warn'" mat-icon-button>delete</mat-icon>
              <span>Eliminar</span>
            </a>
            <a mat-menu-item (click)="modalQR(element)">
              <mat-icon mat-icon-button>qr_code_2</mat-icon>
              <span>Generar QR</span>
            </a>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </mat-card-content>
</mat-card>
